import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Input,
  Button,
  Select,
  useDisclosure,
} from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import ChangePasswordModal from "./ChangePasswordModal";

const prefixOptions = ["+39", "+44", "+33", "+49", "+34", "+1", "+91"];

export default function ProfileCard({
  user,
  customerName,
  onSave,
  refresh,
}) {
  const [editable, setEditable] = useState(false);
  const [formData, setFormData] = useState({
    email: user.email,
    phone: user.phone || "",
  });
  const [prefix, setPrefix] = useState(
    user.phone?.startsWith("+") ? user.phone.slice(0, 3) : ""
  );

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleLocalSave = () => {
    onSave({ email: formData.email, phone: prefix + formData.phone });
    setEditable(false);
  };

  return (
    <Box
      bg="white"
      p={6}
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.200"
      boxShadow="md"
      _hover={{ boxShadow: "lg", transform: "translateY(-2px)" }}
      transition="all 0.15s ease"
    >
      <Flex align="center" justify="start" gap={2} mb={4}>
        <Box as={FaUser} boxSize="1.25em" marginBottom={4}/>
        <Text fontWeight="bold" fontSize="lg" >
          Profilo Utente
        </Text>
      </Flex>

      <Text>Nome</Text>
      <Input mb={3} value={user.name} isReadOnly />

      <Text>Email</Text>
      <Input
        mb={3}
        value={formData.email}
        isReadOnly={!editable}
        onChange={(e) =>
          setFormData({ ...formData, email: e.target.value })
        }
        isInvalid={editable && !/\S+@\S+\.\S+/.test(formData.email)}
      />

      <Text>Telefono</Text>
      <Flex mb={3} gap={2}>
        <Select
          w="30%"
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
          isDisabled={!editable}
          placeholder="Prefisso"
        >
          {prefixOptions.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </Select>
        <Input
          w="70%"
          value={
            formData.phone.startsWith("+")
              ? formData.phone.slice(3)
              : formData.phone
          }
          isReadOnly={!editable}
          onChange={(e) =>
            setFormData({ ...formData, phone: e.target.value })
          }
          isInvalid={editable && !/^[0-9]{5,}$/.test(formData.phone)}
        />
      </Flex>

      <Text>Azienda</Text>
      <Input mb={4} value={customerName} isReadOnly />

      {!editable ? (
        <Flex gap={3}>
          <Button
            colorScheme="teal"
            onClick={() => setEditable(true)}
          >
            Modifica
          </Button>
          <Button onClick={onOpen}>Cambia password</Button>
        </Flex>
      ) : (
        <Flex gap={3}>
          <Button colorScheme="green" onClick={handleLocalSave}>
            Salva
          </Button>
          <Button
            onClick={() => {
              setEditable(false);
              refresh();
            }}
          >
            Annulla
          </Button>
        </Flex>
      )}

      {/* Modal password */}
      <ChangePasswordModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
}
